import React from 'react'

export const ContentRoom3 = (props) => {
  const string = props.stringToRet;

  return (
    <>
      {(string === 'def') && (
        <></>
      )}

      {(string === 'scaffaledx') && (
        <svg className="scaffaledxSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 213.88 316.75">

          <g id="d" data-name="scaffaledx">
            <rect className="q" x=".5" y=".38" width="213" height="316" transform="translate(214 316.75) rotate(180)"/>
            <g id="e" data-name="texture">
              <line className="p" x1="209.24" y1="316.38" x2="213.5" y2="313.06"/>
              <line className="p" x1="201.54" y1="316.38" x2="213.5" y2="307.06"/>
              <line className="p" x1="193.85" y1="316.38" x2="213.5" y2="301.06"/>
              <line className="p" x1="186.15" y1="316.38" x2="213.5" y2="295.06"/>
              <line className="p" x1="178.46" y1="316.38" x2="213.5" y2="289.06"/>
              <line className="p" x1="170.76" y1="316.38" x2="213.5" y2="283.06"/>
              <line className="p" x1="168.5" y1="312.14" x2="213.5" y2="277.06"/>
              <line className="p" x1="168.5" y1="306.14" x2="213.5" y2="271.06"/>
              <line className="p" x1="168.5" y1="300.14" x2="213.5" y2="265.06"/>
              <line className="p" x1="168.5" y1="294.14" x2="213.5" y2="259.06"/>
              <line className="p" x1="168.5" y1="288.14" x2="213.5" y2="253.06"/>
              <line className="p" x1="168.5" y1="282.14" x2="213.5" y2="247.06"/>
              <line className="p" x1="168.5" y1="276.14" x2="213.5" y2="241.06"/>
              <line className="p" x1="168.5" y1="270.14" x2="213.5" y2="235.06"/>
              <line className="p" x1="168.5" y1="264.14" x2="213.5" y2="229.06"/>
              <line className="p" x1="168.5" y1="258.14" x2="213.5" y2="223.06"/>
              <line className="p" x1="168.5" y1="252.14" x2="213.5" y2="217.06"/>
              <line className="p" x1="168.5" y1="246.14" x2="213.5" y2="211.06"/>
              <line className="p" x1="168.5" y1="240.14" x2="213.5" y2="205.06"/>
              <line className="p" x1="168.5" y1="234.14" x2="213.5" y2="199.06"/>
              <line className="p" x1="168.5" y1="228.14" x2="213.5" y2="193.06"/>
              <line className="p" x1="168.5" y1="222.14" x2="213.5" y2="187.06"/>
              <line className="p" x1="168.5" y1="216.14" x2="213.5" y2="181.06"/>
              <line className="p" x1="168.5" y1="210.14" x2="213.5" y2="175.06"/>
              <line className="p" x1="168.5" y1="204.14" x2="213.5" y2="169.06"/>
              <line className="p" x1="168.5" y1="198.14" x2="213.5" y2="163.06"/>
              <line className="p" x1="168.5" y1="192.14" x2="213.5" y2="157.06"/>
              <line className="p" x1="168.5" y1="186.14" x2="213.5" y2="151.06"/>
              <line className="p" x1="168.5" y1="180.14" x2="213.5" y2="145.06"/>
              <line className="p" x1="168.5" y1="174.14" x2="213.5" y2="139.06"/>
              <line className="p" x1="168.5" y1="168.14" x2="213.5" y2="133.06"/>
              <line className="p" x1="168.5" y1="162.14" x2="213.5" y2="127.06"/>
              <line className="p" x1="168.5" y1="156.14" x2="213.5" y2="121.06"/>
              <line className="p" x1="168.5" y1="150.14" x2="213.5" y2="115.06"/>
              <line className="p" x1="168.5" y1="144.14" x2="213.5" y2="109.06"/>
              <line className="p" x1="168.5" y1="138.14" x2="213.5" y2="103.06"/>
              <line className="p" x1="168.5" y1="132.14" x2="213.5" y2="97.06"/>
              <line className="p" x1="168.5" y1="126.14" x2="213.5" y2="91.06"/>
              <line className="p" x1="168.5" y1="120.14" x2="213.5" y2="85.06"/>
              <line className="p" x1="168.5" y1="114.14" x2="213.5" y2="79.06"/>
              <line className="p" x1="168.5" y1="108.14" x2="213.5" y2="73.06"/>
              <line className="p" x1="168.5" y1="102.14" x2="213.5" y2="67.06"/>
              <line className="p" x1="168.5" y1="96.14" x2="213.5" y2="61.06"/>
              <line className="p" x1="168.5" y1="90.14" x2="213.5" y2="55.06"/>
              <line className="p" x1="168.5" y1="84.14" x2="213.5" y2="49.06"/>
              <line className="p" x1="168.5" y1="78.14" x2="213.5" y2="43.06"/>
              <line className="p" x1="168.5" y1="72.14" x2="213.5" y2="37.06"/>
              <line className="p" x1="168.5" y1="66.14" x2="213.5" y2="31.06"/>
              <line className="p" x1="168.5" y1="60.14" x2="213.5" y2="25.06"/>
              <line className="p" x1="168.5" y1="54.14" x2="213.5" y2="19.06"/>
              <line className="p" x1="168.5" y1="48.14" x2="213.5" y2="13.06"/>
              <line className="p" x1="168.5" y1="42.14" x2="213.5" y2="7.06"/>
              <line className="p" x1="168.5" y1="36.14" x2="213.5" y2="1.06"/>
              <line className="p" x1="168.5" y1="30.14" x2="206.67" y2=".38"/>
              <line className="p" x1="168.5" y1="24.14" x2="198.98" y2=".38"/>
              <line className="p" x1="168.5" y1="18.14" x2="191.28" y2=".38"/>
              <line className="p" x1="168.5" y1="12.14" x2="183.59" y2=".38"/>
              <line className="p" x1="168.5" y1="6.14" x2="175.89" y2=".38"/>
            </g>
            <line id="f" data-name="scaffale" className="p" y1="266.38" x2="168.5" y2="266.38"/>
            <line id="g" data-name="scaffale" className="p" y1="212.52" x2="168.5" y2="212.52"/>
            <line id="h" data-name="scaffale" className="p" y1="158.66" x2="168.5" y2="158.66"/>
            <line id="i" data-name="scaffale" className="p" y1="104.8" x2="168.5" y2="104.8"/>
            <line id="j" data-name="scaffale" className="p" x1="168.25" y1=".55" x2="168.25" y2="316.05"/>
            <line id="k" data-name="scaffale" className="p" y1="50.94" x2="168.5" y2="50.94"/>
            <rect className="r" x="27.5" y="233.38" width="9" height="33" rx="1.37" ry="1.37"/>
            <rect className="r" x="36.5" y="233.38" width="9" height="33" rx="1.37" ry="1.37"/>
            <rect className="r" x="103.5" y="233.38" width="9" height="33" rx="1.37" ry="1.37"/>
            <rect className="s" x="112.5" y="233.38" width="9" height="33" rx="1.37" ry="1.37"/>
            <rect className="r" x="85.5" y="233.38" width="9" height="33" rx="1.37" ry="1.37"/>
            <rect className="s" x="52.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="t" x="18.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="s" x="131.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="s" x="140.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="t" x="94.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="s" x="76.5" y="227.38" width="9" height="39" rx="1.37" ry="1.37"/>
            <rect className="s" x="31.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="r" x="40.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="t" x="107.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="r" x="126.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="r" x="89.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="r" x="56.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="r" x="22.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="r" x="135.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="s" x="144.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="s" x="98.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="s" x="65.5" y="277.38" width="9" height="39" rx="1.13" ry="1.13"/>
            <rect className="t" x="13.5" y="283.38" width="9" height="33" rx="1.13" ry="1.13"/>
            <rect className="r" x="138.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="r" x="147.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="t" x="129.5" y="173.38" width="9" height="39" rx="1.53" ry="1.53"/>
            <rect className="s" x="83.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="s" x="92.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="r" x="65.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="r" x="74.5" y="173.38" width="9" height="39" rx="1.53" ry="1.53"/>
            <rect className="t" x="56.5" y="173.38" width="9" height="39" rx="1.53" ry="1.53"/>
            <rect className="r" x="31.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="s" x="40.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="t" x="22.5" y="173.38" width="9" height="39" rx="1.53" ry="1.53"/>
            <rect className="r" x="13.5" y="179.38" width="9" height="33" rx="1.53" ry="1.53"/>
            <rect className="r" x="137.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="t" x="146.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="r" x="119.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="t" x="128.5" y="11.94" width="9" height="39" rx="1.68" ry="1.68"/>
            <rect className="s" x="110.5" y="11.94" width="9" height="39" rx="1.68" ry="1.68"/>
            <rect className="t" x="14.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="r" x="23.5" y="11.94" width="9" height="39" rx="1.68" ry="1.68"/>
            <rect className="r" x="32.5" y="11.94" width="9" height="39" rx="1.68" ry="1.68"/>
            <rect className="t" x="85.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="s" x="94.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="r" x="76.5" y="11.94" width="9" height="39" rx="1.68" ry="1.68"/>
            <rect className="s" x="67.5" y="17.94" width="9" height="33" rx="1.68" ry="1.68"/>
            <rect className="r" x="133.5" y="125.66" width="9" height="33" rx="1.48" ry="1.48"/>
            <rect className="t" x="142.5" y="119.66" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="r" x="151.5" y="119.66" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="r" x="99.29" y="125.53" width="9" height="33" rx="1.48" ry="1.48"/>
            <rect className="s" x="108.29" y="125.53" width="9" height="33" rx="1.48" ry="1.48"/>
            <rect className="r" x="81.29" y="125.53" width="9" height="33" rx="1.48" ry="1.48"/>
            <rect className="t" x="8.29" y="119.53" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="r" x="117.29" y="119.53" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="t" x="90.29" y="119.53" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="s" x="17.29" y="119.53" width="9" height="39" rx="1.48" ry="1.48"/>
            <rect className="t" x="131.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(272 176.6) rotate(180)"/>
            <rect className="r" x="122.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(254 176.6) rotate(180)"/>
            <rect className="r" x="55.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(120 176.6) rotate(180)"/>
            <rect className="s" x="46.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(102 176.6) rotate(180)"/>
            <rect className="r" x="73.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(156 176.6) rotate(180)"/>
            <rect className="r" x="106.5" y="65.8" width="9" height="39" rx="1.64" ry="1.64" transform="translate(222 170.6) rotate(180)"/>
            <rect className="r" x="140.5" y="65.8" width="9" height="39" rx="1.64" ry="1.64" transform="translate(290 170.6) rotate(180)"/>
            <rect className="t" x="27.5" y="65.8" width="9" height="39" rx="1.64" ry="1.64" transform="translate(64 170.6) rotate(180)"/>
            <rect className="r" x="18.5" y="65.8" width="9" height="39" rx="1.64" ry="1.64" transform="translate(46 170.6) rotate(180)"/>
            <rect className="t" x="64.5" y="65.8" width="9" height="39" rx="1.64" ry="1.64" transform="translate(138 170.6) rotate(180)"/>
            <rect className="r" x="9.5" y="71.8" width="9" height="33" rx="1.64" ry="1.64" transform="translate(28 176.6) rotate(180)"/>
            <g id="l" className="diario">
              <rect className="u" x="37.09" y="116.53" width="33" height="42" rx=".7" ry=".7"/>
              <rect className="n" x="45.28" y="123.03" width="16.62" height="9" rx="1.98" ry="1.98"/>
              <text className="o" transform="translate(46.64 128.75)">
                <tspan x="0" y="0">DI</tspan>
                <tspan className="m" x="4.2" y="0">A</tspan>
                <tspan className="v" x="6.93" y="0">R</tspan>
                <tspan x="9.6" y="0">IO</tspan>
              </text>
            </g>
          </g>
        </svg>
      )}

      {(string === 'pavimento') && (
        <svg className="pavimentoSvg" xmlns="http://www.w3.org/2000/svg">
          <pattern id="patternPavimento" data-name="Capsule" x="0" y="0" width="57.6" height="57.6" patternTransform="translate(9.54 773.9)" patternUnits="userSpaceOnUse" viewBox="0 0 57.6 57.6">
            <g>
              <rect className="h" x="0" y="0" width="57.6" height="57.6"/>
              <line className="i" x1="58.11" y1="14.48" x2="62.26" y2="13.45"/>
              <g>
                <line className="i" x1="25.8" y1="31.8" x2="23.59" y2="35.46"/>
                <line className="i" x1="23.23" y1="24.91" x2="24.99" y2="28.13"/>
                <line className="i" x1="21.75" y1="27.35" x2="21.97" y2="32.17"/>
                <line className="i" x1="30.78" y1="44.12" x2="31.58" y2="48.31"/>
                <line className="i" x1="17.5" y1="38.69" x2="16.71" y2="42.89"/>
                <line className="i" x1="9.87" y1="39.16" x2="13.17" y2="41.87"/>
                <line className="i" x1="17.5" y1="33.44" x2="20.8" y2="36.15"/>
                <line className="i" x1="21.67" y1="43.39" x2="20.2" y2="39.38"/>
                <line className="i" x1="9.45" y1="42.01" x2="5.25" y2="45.6"/>
                <line className="i" x1="15.12" y1="31.3" x2="19.23" y2="30.12"/>
                <line className="i" x1="23.79" y1="50.9" x2="27.23" y2="48.36"/>
                <line className="i" x1="15.11" y1="52.77" x2="17.32" y2="49.11"/>
                <line className="i" x1="33.75" y1="34.15" x2="35.43" y2="38.08"/>
                <line className="i" x1="41.75" y1="24.85" x2="41.2" y2="30.6"/>
                <line className="i" x1="30.57" y1="38.9" x2="28.44" y2="42.61"/>
                <line className="i" x1="39.67" y1="38.73" x2="36.36" y2="41.44"/>
                <line className="i" x1="38.59" y1="52.05" x2="41.91" y2="54.74"/>
                <line className="i" x1="36.91" y1="32.47" x2="40.2" y2="35.2"/>
                <line className="i" x1="30.08" y1="34.59" x2="31.57" y2="30.58"/>
                <line className="i" x1="34.28" y1="30.47" x2="37.92" y2="28.22"/>
                <line className="i" x1="10.02" y1="47.92" x2="12.5" y2="44.44"/>
                <line className="i" x1="41" y1="20.38" x2="38.61" y2="23.93"/>
                <line className="i" x1="14" y1="37.85" x2="12.28" y2="32.64"/>
                <line className="i" x1="13.16" y1="17.15" x2="15.93" y2="13.89"/>
                <line className="i" x1="34.69" y1="21.86" x2="34.25" y2="27.35"/>
                <line className="i" x1="21.5" y1="23.35" x2="23.41" y2="18.74"/>
                <line className="i" x1="25.72" y1="42.06" x2="24.3" y2="46.09"/>
                <line className="i" x1="31.69" y1="41.64" x2="35" y2="44.35"/>
                <line className="i" x1="16.34" y1="21.93" x2="19" y2="26.6"/>
                <line className="i" x1="25.13" y1="55.12" x2="28.77" y2="52.87"/>
                <line className="i" x1="14.98" y1="28.92" x2="10.85" y2="27.81"/>
                <line className="i" x1="14.37" y1="20.32" x2="12.75" y2="23.35"/>
                <line className="i" x1="45.75" y1="5.85" x2="46" y2="11"/>
                <line className="i" x1="30.46" y1="3.36" x2="33.77" y2="6.07"/>
                <line className="i" x1="25.25" y1="5.35" x2="20.96" y2="8.34"/>
                <line className="i" x1="13.76" y1="2.28" x2="17.5" y2="4.85"/>
                <line className="i" x1="27.85" y1="16.5" x2="30" y2="20.2"/>
                <line className="i" x1="30" y1="9.1" x2="29.45" y2="12.48"/>
                <line className="i" x1="33.31" y1="8.65" x2="37.23" y2="10.36"/>
                <line className="i" x1="25.51" y1="9.77" x2="27.71" y2="6.11"/>
                <line className="i" x1="48.25" y1="21.1" x2="44.41" y2="24.49"/>
                <line className="i" x1="17.75" y1="19.6" x2="19.65" y2="14.7"/>
                <line className="i" x1="16.67" y1="8.58" x2="19.71" y2="11.59"/>
                <line className="i" x1="42.22" y1="4.71" x2="40" y2="8.6"/>
                <line className="i" x1="44.5" y1="15.09" x2="44.59" y2="19.37"/>
                <line className="i" x1="40.62" y1="12.39" x2="44.88" y2="12.6"/>
                <line className="i" x1="25.86" y1="12.96" x2="22.56" y2="15.68"/>
                <line className="i" x1="45.25" y1="30.68" x2="43.56" y2="34.61"/>
                <line className="i" x1="50.08" y1="38.59" x2="50.8" y2="42.8"/>
                <line className="i" x1="50.7" y1="33.6" x2="52.28" y2="37.58"/>
                <line className="i" x1="50.74" y1="46.68" x2="47.45" y2="49.41"/>
                <line className="i" x1="52.6" y1="50.24" x2="54.81" y2="46.58"/>
                <line className="i" x1="43.48" y1="45.25" x2="44.5" y2="50.35"/>
                <line className="i" x1="54.61" y1="23.34" x2="50.35" y2="23.02"/>
                <line className="i" x1="56.36" y1="40.21" x2="53.08" y2="42.94"/>
                <line className="i" x1="47.65" y1="36.43" x2="45.85" y2="40.31"/>
                <line className="i" x1="53.43" y1="26.2" x2="56.59" y2="29.08"/>
                <line className="i" x1="7.75" y1="5.35" x2="5.03" y2="8.35"/>
                <line className="i" x1="14.01" y1="10.21" x2="10.71" y2="12.92"/>
                <line className="i" x1="11.18" y1="2.54" x2="12.41" y2="6.64"/>
                <line className="i" x1="47.75" y1="30.75" x2="52" y2="31.23"/>
                <line className="i" x1="6.75" y1="47.81" x2="5.07" y2="51.74"/>
                <line className="i" x1="8.29" y1="52.97" x2="5" y2="55.7"/>
                <line className="i" x1="6.13" y1="29.9" x2="9.42" y2="32.64"/>
                <line className="i" x1="48.93" y1="7.12" x2="52.57" y2="4.87"/>
                <line className="i" x1="50.22" y1="9.62" x2="48.8" y2="13.65"/>
                <line className="i" x1=".51" y1="14.48" x2="4.66" y2="13.45"/>
                <line className="i" x1="2.51" y1="28.91" x2="4.73" y2="25.25"/>
                <line className="i" x1="5.56" y1="18.33" x2="2.28" y2="21.06"/>
                <line className="i" x1="7.34" y1="14.93" x2="9.5" y2="18.6"/>
                <line className="i" x1="5.75" y1="21.1" x2="8.49" y2="25.63"/>
                <line className="i" x1="4.01" y1="32.39" x2="3.22" y2="36.59"/>
                <line className="i" x1="9.5" y1="35.6" x2="5.49" y2="38.68"/>
                <line className="i" x1="11.45" y1="49.91" x2="11.77" y2="54.17"/>
                <line className="i" x1="34.75" y1="12.6" x2="30.81" y2="15.89"/>
                <line className="i" x1="37.38" y1="13.27" x2="39.53" y2="16.97"/>
                <line className="i" x1="33.31" y1="17.56" x2="37.13" y2="19.48"/>
                <line className="i" x1="28.46" y1="36.85" x2="25.16" y2="39.56"/>
                <line className="i" x1="20.2" y1="44.7" x2="16.23" y2="46.28"/>
                <line className="i" x1="20" y1="50.1" x2="22" y2="54.35"/>
                <line className="i" x1="36.25" y1="47.35" x2="40.26" y2="48.82"/>
                <line className="i" x1="37" y1="3.1" x2="36.59" y2="7.48"/>
                <line className="i" x1="40.85" y1="41.63" x2="39.8" y2="45.78"/>
                <line className="i" x1="36.17" y1="49.7" x2="32.07" y2="50.93"/>
                <line className="i" x1="32.5" y1="23.6" x2="28.66" y2="27.73"/>
                <line className="i" x1="49.95" y1="51.35" x2="51.63" y2="55.28"/>
                <line className="i" x1="56.21" y1="36.53" x2="59.51" y2="39.24"/>
                <line className="i" x1="56.96" y1="46.23" x2="60.26" y2="48.94"/>
                <line className="i" x1="54.21" y1="32.17" x2="58.32" y2="30.99"/>
                <line className="i" x1="56.44" y1="21.41" x2="58.59" y2="25.1"/>
                <line className="i" x1="58.11" y1="14.48" x2="62.26" y2="13.45"/>
                <line className="i" x1="59" y1="51.6" x2="55.71" y2="54.33"/>
                <line className="i" x1="51.15" y1="14.55" x2="52.83" y2="18.48"/>
                <line className="i" x1="60.33" y1="42.9" x2="56.15" y2="43.82"/>
                <line className="i" x1="50.93" y1="26.1" x2="45.75" y2="27.35"/>
                <line className="i" x1="6.07" y1="11.21" x2="9.6" y2="8.8"/>
                <line className="i" x1="45.04" y1="42.43" x2="48.04" y2="45.48"/>
                <line className="i" x1="53.09" y1="8.66" x2="55.09" y2="12.44"/>
                <line className="i" x1="59.06" y1="17.93" x2="54.8" y2="17.6"/>
                <line className="i" x1="26.36" y1="19.81" x2="27.5" y2="24.85"/>
                <line className="i" x1="42.16" y1="36.41" x2="43" y2="40.6"/>
                <line className="i" x1="47.21" y1="17.96" x2="50.96" y2="20.03"/>
                <line className="i" x1="35" y1="54.35" x2="31.97" y2="53.38"/>
                <line className="i" x1="20.65" y1="1.85" x2="20.2" y2="6.1"/>
                <line className="i" x1="2" y1="5.6" x2="3" y2="10.85"/>
                <line className="i" x1="56.25" y1="8.1" x2="57.74" y2="4.1"/>
                <line className="i" x1="47.75" y1="52.73" x2="46" y2="56.6"/>
                <line className="i" x1="44.33" y1="59.77" x2="40.66" y2="57.58"/>
                <line className="i" x1="29.5" y1="55.2" x2="27.71" y2="60.69"/>
                <line className="i" x1="21.5" y1="56.45" x2="24.5" y2="60.7"/>
                <line className="i" x1="50.93" y1="57.37" x2="47.63" y2="60.08"/>
                <line className="i" x1="8.53" y1="55.83" x2="7.6" y2="60"/>
                <line className="i" x1="15" y1="55.6" x2="11.75" y2="57.95"/>
                <line className="i" x1="1.6" y1="55.4" x2="2.4" y2="59.6"/>
                <line className="i" x1="54" y1="60.4" x2="56.21" y2="56.74"/>
                <line className="i" x1="34" y1="60.7" x2="33.97" y2="57.43"/>
                <line className="i" x1="16.91" y1="54.14" x2="17.62" y2="58.35"/>
                <line className="i" x1="37.15" y1="55.8" x2="39" y2="59.1"/>
              </g>
              <g>
                <line className="i" x1="-1.39" y1="36.53" x2="1.91" y2="39.24"/>
                <line className="i" x1="-.64" y1="46.23" x2="2.66" y2="48.94"/>
                <line className="i" x1="-3.38" y1="32.17" x2=".72" y2="30.99"/>
                <line className="i" x1="-1.16" y1="21.41" x2=".99" y2="25.1"/>
                <line className="i" x1=".51" y1="14.48" x2="4.66" y2="13.45"/>
                <line className="i" x1="1.4" y1="51.6" x2="-1.89" y2="54.33"/>
                <line className="i" x1="2.73" y1="42.9" x2="-1.45" y2="43.82"/>
                <line className="i" x1="1.46" y1="17.93" x2="-2.8" y2="17.6"/>
                <line className="i" x1="-1.35" y1="8.1" x2=".14" y2="4.1"/>
              </g>
              <g>
                <line className="i" x1="44.33" y1="2.17" x2="40.66" y2="-.02"/>
                <line className="i" x1="29.5" y1="-2.4" x2="27.71" y2="3.09"/>
                <line className="i" x1="21.5" y1="-1.15" x2="24.5" y2="3.1"/>
                <line className="i" x1="50.93" y1="-.23" x2="47.63" y2="2.48"/>
                <line className="i" x1="8.53" y1="-1.77" x2="7.6" y2="2.4"/>
                <line className="i" x1="15" y1="-2" x2="11.75" y2=".35"/>
                <line className="i" x1="1.6" y1="-2.2" x2="2.4" y2="2"/>
                <line className="i" x1="54" y1="2.8" x2="56.21" y2="-.86"/>
                <line className="i" x1="34" y1="3.1" x2="33.97" y2="-.17"/>
                <line className="i" x1="16.91" y1="-3.46" x2="17.62" y2=".75"/>
                <line className="i" x1="37.15" y1="-1.8" x2="39" y2="1.5"/>
              </g>
            </g>
          </pattern>
          <rect className="j" x=".25" y=".25" width="100%" height="100%"/>
          <g className="k">
            <rect className="g" x=".04" y="1.4" width="100%" height="100%"/>
          </g>
        </svg>
      )}

    </>
  )
}
